<div class="container-nuestra-facultad">
  <section class="contacto-container">
   <div class="contacto-imagen">
    <img class="desk" src="./assets/facultades/Contacto Desk.png" alt="UCA Edificio Contáctanos">
    <img class="mob" src="./assets/facultades/Contacto Mob.png" alt="UCA Edificio Contáctanos">
    <!--<div class="overlay-texto">
      <h2>Contacto</h2>
      <p class="subtitulo">Estamos para ayudarte.</p>
      <p class="descripcion">Si tenés dudas o necesitás más información, escribinos.</p>
    </div>-->
  </div>

<div class="contacto-card">
  <div class="contacto-card-item">
   <img src="./assets/facultades/clock.png" alt="">
   <div class="contacto-card-texts">
      <span class="nunito-bold">Horario de atención</span>
      <p class="ninuto-mediun">
         {{ info?.venue_contact?.diasDesde === 'Lunes' ? 'Lun' : info?.venue_contact?.diasDesde === 'Martes' ? 'Mar' : info?.venue_contact?.diasDesde === 'Miércoles' ? 'Mier' : info?.venue_contact?.diasDesde === 'Jueves' ? 'Jue' : info?.venue_contact?.diasDesde === 'Viernes' ? 'Vier' : info?.venue_contact?.diasDesde }}
         a
         {{ info?.venue_contact?.diasHasta === 'Lunes' ? 'Lun' : info?.venue_contact?.diasHasta === 'Martes' ? 'Mar' : info?.venue_contact?.diasHasta === 'Miércoles' ? 'Mier' : info?.venue_contact?.diasHasta === 'Jueves' ? 'Jue' : info?.venue_contact?.diasHasta === 'Viernes' ? 'Vier' : info?.venue_contact?.diasHasta }}
         de {{ info?.venue_contact?.horaDesde }} a {{ info?.venue_contact?.horaHasta }}hs
      </p>
      <hr class="divider mob">
   </div>

</div>

<div class="contacto-card-item">
   <img src="./assets/facultades/location.png" alt="">
   <div class="contacto-card-texts">
      <span class="nunito-bold">Dirección</span>
      <a 
         [href]="info?.venue?.mapsUrl"
         target="_blank" 
         rel="noopener noreferrer" 
         class="ninuto-mediun">
        <p class="ninuto-mediun">{{ info?.venue_contact?.address }}</p>
      </a>
      <hr class="divider mob">
   </div>
</div>

<div class="contacto-card-item">
   <img src="./assets/facultades/email.png" alt="">
   <div class="contacto-card-texts">
      <span class="nunito-bold">E-mail</span>
      <a 
         [href]="'mailto:' + info?.venue_contact?.email" 
         class="ninuto-medium">
         <p class="ninuto-mediun">{{ info?.venue_contact?.email }} </p>
      </a>
      <hr class="divider mob">
   </div>
</div>
<div class="contacto-botones" *ngIf="info?.venue_contact?.showContactButton">
      <button
         type="button"
         class="btn-contacto nunito-medium zoomIn"
         (click)="openContactModal()">
         CONTACTOS FCE
      </button>
</div>
  <!-- Redes Sociales -->
  <div class="redes-facultad" *ngIf="info?.venue_contact?.facebookUrl || info?.venue_contact?.igUrl || info?.venue_contact?.linkedinUrl || info?.venue_contact?.twitterUrl
         || info?.venue_contact?.tiktokUrl || info?.venue_contact?.youtubeUrl">
            <h2 class="nunito-bold">Nuestras redes</h2>
            <div class="iconos-redes">
               <!-- Facebook -->
               <a *ngIf="info?.venue_contact?.facebookUrl" [href]="info?.venue_contact?.facebookUrl" target="_blank"
                  rel="noopener noreferrer">
                  <img src="./assets/img/facebook5.png" alt="Facebook">
               </a>

               <!-- Instagram -->
               <a *ngIf="info?.venue_contact?.igUrl" [href]="info?.venue_contact?.igUrl" target="_blank"
                  rel="noopener noreferrer">
                  <img src="./assets/img/instagram2.png" alt="Instagram">
               </a>

               <!-- LinkedIn -->
               <a *ngIf="info?.venue_contact?.linkedinUrl" [href]="info?.venue_contact?.linkedinUrl" target="_blank"
                  rel="noopener noreferrer">
                  <img src="./assets/img/in2.png" alt="LinkedIn">
               </a>

               <!-- Twitter / X -->
               <a *ngIf="info?.venue_contact?.twitterUrl" [href]="info?.venue_contact?.twitterUrl" target="_blank"
                  rel="noopener noreferrer">
                  <img src="./assets/img/X2.png" alt="X / Twitter">
               </a>

               <!-- TikTok -->
               <a *ngIf="info?.venue_contact?.tiktokUrl" [href]="info?.venue_contact?.tiktokUrl" target="_blank"
                  rel="noopener noreferrer">
                  <img src="./assets/img/tiktok2.png" alt="TikTok">
               </a>

               <!-- YouTube -->
               <a *ngIf="info?.venue_contact?.youtubeUrl" [href]="info?.venue_contact?.youtubeUrl" target="_blank"
                  rel="noopener noreferrer">
                  <img src="./assets/img/youtube2.png" alt="YouTube">
               </a>
            </div>
         </div>
</div>
  </section>
</div>

<app-modal-contacto-facultad
   [isOpen]="isContactModalOpen"
   [data]="info?.venue_contact"
   (closed)="closeContactModal()">
</app-modal-contacto-facultad>
